<div class="page-wrap">
  <div class="pinned">
    <div class="title">
      <nb-route-tabset [tabs]="tabs" [fullWidth]="true" [activeLinkOptions]="{exact: false}"></nb-route-tabset>
    </div>
    <div class="buttons">
      @if (count !== null) {
        <label class="count">{{ 'results' | plural:count | translate:{value: count} }}</label>
      }
      @if (admin && finals.length) {
        <div class="download">
          <div class="row">
            <!-- The Schedules overview's date range field (table-object): the picker, and presets under the chevron. -->
            <div class="dates">
              <input #rangefield nbInput fieldSize="small" [attr.aria-label]="'invoice.zip_range' | translate" [placeholder]="'enterdaterange' | translate" [formControl]="dates" [nbDatepicker]="rangepicker">
              <nb-rangepicker #rangepicker></nb-rangepicker>
              <button nbButton size="small" [nbPopover]="presetTpl" nbPopoverTrigger="click" nbPopoverPlacement="bottom" #datePop="nbPopover" [attr.aria-label]="'enterdaterange' | translate">
                <nb-icon icon="arrow-ios-downward"></nb-icon>
              </button>
              <ng-template #presetTpl>
                <div class="kebab-popup">
                  @for (p of presets; track p) { <button class="kebab-item" (click)="applyPreset(p)">{{ 'invoice.range.' + p | translate }}</button> }
                </div>
              </ng-template>
            </div>
            <button nbButton size="small" shape="semi-round" status="basic" [disabled]="busy || !!pending || !inRange.length" (click)="downloadAll()"><nb-icon icon="download-outline"></nb-icon>{{ 'invoice.download_zip' | plural:inRange.length | translate:{value: inRange.length} }}</button>
          </div>
          @if (pending) { <small class="hint">{{ 'invoice.zip_pending' | translate:{numbers: pending} }}</small> }
        </div>
      }
      @if (canCreate) {
        <button nbButton size="small" shape="semi-round" status="primary" (click)="create()"><nb-icon icon="plus-outline"></nb-icon>{{ 'invoice.new' | translate }}</button>
      }
    </div>
  </div>

  <bst-dual-axis [tag]="'invoices'" [delegate]="this" [bootstrap]="true" [pagingMode]="Globals.PagesMode"></bst-dual-axis>
</div>

<!-- bst-dual-axis sends clicks on standard cells to selectRow(), not clicks on the pinned one, so the invoice cell opens it itself. -->
<ng-template #cellTemplate let-invoice="row" let-column="column" let-node="node">
  @switch (column.name) {
    @case ('number') { <a class="nowrap number" (click)="selectRow($event, node)">{{ invoice.number ?? ('invoice.draft_label' | translate:{id: invoice.id}) }}</a> }
    @case ('client') { <span [title]="invoice.client_name">{{ invoice.client_name }}</span> }
    @case ('project') { <span [title]="invoice.project.name">{{ invoice.project.name }}</span> }
    @case ('period') { <!-- One year written once (1 okt. – 18 okt. 2026): the table fits 1440 in Dutch without a sideways scroll. --><span class="nowrap">{{ invoice.period_from | localedate:(invoice.period_from.slice(0, 4) === invoice.period_to.slice(0, 4) ? 'D MMM' : 'D MMM YYYY') }} – {{ invoice.period_to | localedate:'D MMM YYYY' }}</span> }
    @case ('invoice_date') { @if (invoice.invoice_date) { <span class="nowrap">{{ invoice.invoice_date | localedate:'D MMM YYYY' }}</span> } @else { <span class="muted">–</span> } }
    @case ('due_date') { @if (invoice.due_date) { <span class="nowrap">{{ invoice.due_date | localedate:'D MMM YYYY' }}</span> } @else { <span class="muted">–</span> } }
    @case ('status') { <bst-invoice-status [invoice]="invoice"></bst-invoice-status> }
    @case ('total') { @if (invoice.gross_cents !== null) { <span class="num">{{ invoice.gross_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }}</span> } @else { <span class="muted">–</span> } }
  }
</ng-template>

<!-- Phone width: bst-dual-axis renders one card per invoice and sends its click to selectRow(). -->
<ng-template #cardTemplate let-invoice="row">
  <div class="i-card">
    <div class="i-card-head">
      <strong>{{ invoice.number ?? ('invoice.draft_label' | translate:{id: invoice.id}) }}</strong>
      <bst-invoice-status [invoice]="invoice"></bst-invoice-status>
    </div>
    <div class="i-card-meta">
      <span>{{ invoice.client_name }}</span>
      @if (invoice.gross_cents !== null) { <span class="num">{{ invoice.gross_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }}</span> }
    </div>
    <div class="i-card-sub">{{ invoice.project.name }} · {{ invoice.period_from | localedate:'D MMM YYYY' }} – {{ invoice.period_to | localedate:'D MMM YYYY' }}</div>
  </div>
</ng-template>
